import { fetchData } from './fetchData';
import { FrontCategory } from '../data/FrontCategory';

function frontCategory(): Promise<FrontCategory[]> {
    return fetchData('api/front_category', {
        method: 'POST',
        body: JSON.stringify({}),
    })
        .then((res) => res.json())
        .then((resData: FrontCategory[]) => resData);
}

export { frontCategory };
